import instance from '@apis/instance';
import {
  CouponRow,
  DownloadableCouponRow,
  UserCouponResponse,
  GetCouponsParams,
  GetDownloadableCouponsParams,
} from '@models/coupon';
import { SliceResponse } from '@models/page';

class CouponApi {
  static getMyCoupons(params: GetCouponsParams): Promise<SliceResponse<CouponRow>> {
    return instance.get('/user-coupons', { params });
  }

  static getMyCoupon(id: string): Promise<UserCouponResponse> {
    return instance.get(`/user-coupon/${id}`);
  }

  static getCouponHistories(params: GetCouponsParams): Promise<SliceResponse<CouponRow>> {
    return instance.get('/user-coupons/history', { params });
  }

  static getDownloadableCoupons(params: GetDownloadableCouponsParams): Promise<SliceResponse<DownloadableCouponRow>> {
    return instance.get('/coupons/download-event', { params });
  }

  static downloadCoupon(eventId: string) : Promise<never> {
    return instance.post(`/coupons/download-event/${eventId}`);
  }
}

export default CouponApi;
